export default __webpack_public_path__ + "static/media/PSAL.ae48aed6.png";